import styled from '@emotion/styled';

const List = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing[50]};
`;
export { List };
